import { makeStyles } from '@material-ui/core';

export const MembershipTypeRadioGroupStyle = makeStyles({
    root: {
        padding: '16px 0 0 16px',
    },
});
